import { yupResolver } from '@hookform/resolvers/yup'
import { useState } from 'react'
import { useForm } from 'react-hook-form'

import BaseButton from 'components/common/BaseButton'
import BaseInputText from 'components/common/BaseInputText'
import BaseAuthLayout from 'layouts/BaseAuthLayout'
import { IResetPassword } from 'models/auth'
import { useMutation } from 'react-query'
import { resetPassword } from 'services/auth.service'
import { resetPasswordSchema } from 'validation/auth'
import IconEmail from 'components/icons/IconEmail'
import { useTranslation } from 'react-i18next'
import useNotification from 'hooks/useNotification'
import { VALIDATIONS } from 'validation/admin'

type FormData = {
  email: string
  password: string
}

export default function BaseResetPassword() {
  const { t } = useTranslation()
  const { handleApiError } = useNotification()
  const [sent, setSent] = useState<boolean>(false)

  const { handleSubmit, control } = useForm<FormData>({
    resolver: yupResolver(resetPasswordSchema),
    mode: 'all'
  })

  const { mutateAsync } = useMutation({
    mutationFn: resetPassword,
    onError: handleApiError(t('auth.title_reset_fail')),
    onSuccess: () => {
      setSent(true)
    }
  })

  const onSubmit = async (values: IResetPassword) => {
    mutateAsync(values)
  }

  return (
    <BaseAuthLayout title={t('auth.reset_password')}>
      {sent ? (
        <p className='mb-6 font-medium text-base text-neutral-300 text-center'>{t('auth.reset_message')}</p>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='mb-12'>
            <BaseInputText
              suffix={<IconEmail />}
              label={t('auth.email')}
              maxLength={VALIDATIONS.MAX_LENGTH_TEXT}
              name='email'
              placeholder={t('auth.placeholder_email')}
              control={control}
            />
          </div>
          <BaseButton htmlType='submit' type='primary' className={'w-full bg-primary-strong'}>
            {t('auth.btn_send')}
          </BaseButton>
        </form>
      )}
    </BaseAuthLayout>
  )
}
